/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Returns__ImportantInputs */

const en_help_center__refund_policy__returns__important = /** @type {((inputs: Help_Center__Refund_Policy__Returns__ImportantInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Returns__ImportantInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Returns__ImportantInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Important: Opened electronics, vehicles, and items with broken seals may not be eligible for return unless defective.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Returns__ImportantInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Important:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Opened electronics, vehicles, and items with broken seals may not be eligible for return unless defective." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Important: Opened electronics, vehicles, and items with broken seals may not be eligible for return unless defective." |
*
* @param {Help_Center__Refund_Policy__Returns__ImportantInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__returns__important = /** @type {((inputs?: Help_Center__Refund_Policy__Returns__ImportantInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Returns__ImportantInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Returns__ImportantInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Returns__ImportantInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__returns__important(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Returns__ImportantInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__returns__important.parts === "function" ? en_help_center__refund_policy__returns__important.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__returns__important(inputs) }]
			})
		}
	)
);